import { NavLink, useNavigate } from 'react-router-dom'
import Bg from './assets/bg.avif'
import Logo from './assets/ic.png'
import Shopping from './assets/shopping.jpeg'
import { FaAnglesRight } from "react-icons/fa6";
import { useContext, useEffect, useState } from 'react';
import { AppContext } from './context/AppContext';

const Login = () => {

    const { loggedIn, setLoggedIn } = useContext(AppContext)

    const Navigate = useNavigate()

    const [showSignUp, setShowSignUp] = useState(false)
    const [loginInputs, setLoginInputs] = useState({})
    const [regInputs, setRegInputs] = useState({ user_type: 'user' })

    const toggleSignUp = () => {
        setShowSignUp(!showSignUp);
    };

    const handleLoginInputsChange = (e) => {
        const { name, value } = e.target
        setLoginInputs({ ...loginInputs, [name]: value })
    }

    const handleRegInputsChange = (e) => {
        const { name, value } = e.target
        setRegInputs({ ...regInputs, [name]: value })
    }

    const onLoginSubmit = (e) => {
        e.preventDefault()

        console.log(loginInputs)

        setLoggedIn(true)
        window.sessionStorage.setItem("tripstore_login", "true")
        Navigate(-1)
    }

    const onRegSubmit = (e) => {
        e.preventDefault()

        console.log(regInputs)

        setLoggedIn(true)
        window.sessionStorage.setItem("tripstore_login", "true")
        Navigate('/user/dashboard')
    }

    useEffect(() => {
        if (loggedIn) {
            Navigate(-1);
        }
    }, [loggedIn, Navigate])

    return (
        <div className=" relative w-full h-screen bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url(${Bg})` }}>
            <div className=" absolute top-0 left-0 w-full h-full bg-black/10 flex justify-center items-center">
                <div className=" relative rounded-sm overflow-hidden shadow-lg bg-white/90 backdrop-blur-sm w-[95%] max-w-[1000px] flex items-center">
                    <div className={`${showSignUp ? ' hidden sm:block' : ' block'} w-full p-8`}>
                        <NavLink to={'/'}>
                            <img src={Logo} className=' h-[80px] m-auto' alt="" />
                        </NavLink>
                        <div className=" text-gray-500 font-semibold mt-2 text-center">Welcome Back, Please login to your account</div>
                        <form onSubmit={onLoginSubmit} action="" className=' w-full mt-2'>
                            <div className=" flex flex-col my-2">
                                <label htmlFor="log-email" className=' text-sm font-semibold'>Email</label>
                                <input type="email" name='email' id='log-email' onChange={handleLoginInputsChange} required />
                            </div>
                            <div className=" flex flex-col my-2">
                                <label htmlFor="log-pwd" className=' text-sm font-semibold'>Password</label>
                                <input type="password" name='pwd' id='log-pwd' onChange={handleLoginInputsChange} required />
                            </div>
                            <a href="#/" className=' text-sm font-semibold hover:underline mt-2'>Forgot password</a>
                            <button className=' w-full bg-tripstore-black text-white mt-4' type="submit">Login</button>
                        </form>
                        <div className=" mt-4 flex items-center gap-2 text-sm font-semibold">
                            <div className=" flex-1 text-gray-500">Don't have an account yet?</div>
                            <div onClick={toggleSignUp} className=" flex flex-nowrap items-center gap-2 hover:text-tripstore-gold cursor-pointer">
                                <div className=" text-nowrap">Sign Up</div>
                                <FaAnglesRight />
                            </div>
                        </div>
                    </div>
                    <div className={`${showSignUp ? ' block' : ' hidden sm:block'} w-full p-8`}>
                        <NavLink to={'/'}>
                            <img src={Logo} className=' h-[80px] m-auto' alt="" />
                        </NavLink>
                        <div className=" text-gray-500 font-semibold mt-2 text-center">Great to have you, Please register a new account</div>
                        <form onSubmit={onRegSubmit} action="" className=' w-full mt-2'>
                            <div className=" flex flex-col my-2">
                                <label htmlFor="f-name" className=' text-sm font-semibold'>First Name</label>
                                <input type="text" name='first_name' id='f-name' onChange={handleRegInputsChange} required />
                            </div>
                            <div className=" flex flex-col my-2">
                                <label htmlFor="l-name" className=' text-sm font-semibold'>Last Name</label>
                                <input type="text" name='last_name' id='l-name' onChange={handleRegInputsChange} required />
                            </div>
                            <div className=" flex flex-col my-2">
                                <label htmlFor="email" className=' text-sm font-semibold'>Email</label>
                                <input type="email" name='email' id='email' onChange={handleRegInputsChange} required />
                            </div>
                            <div className=" flex flex-col my-2">
                                <label htmlFor="pwd" className=' text-sm font-semibold'>Password</label>
                                <input type="password" name='pwd' id='pwd' onChange={handleRegInputsChange} required />
                            </div>
                            <div className=" flex flex-col my-2">
                                <label htmlFor="c-pwd" className=' text-sm font-semibold'>Confirm Password</label>
                                <input type="password" name='c_pwd' id='c-pwd' onChange={handleRegInputsChange} required />
                            </div>
                            <button className=' w-full bg-tripstore-black text-white mt-4' type="submit">Register</button>
                        </form>
                        <div className=" mt-4 flex items-center gap-2 text-sm font-semibold">
                            <div className=" flex-1 text-gray-500">Already have an account?</div>
                            <div onClick={toggleSignUp} className=" flex flex-nowrap items-center gap-2 hover:text-tripstore-gold cursor-pointer">
                                <div className=" text-nowrap">Login</div>
                                <FaAnglesRight />
                            </div>
                        </div>
                    </div>
                    <div className={`absolute top-0 ${showSignUp ? 'right-[50%]' : 'right-[0%]'} transition-all duration-500 w-[0%] sm:w-[50%] h-full z-10 bg-black`}>
                        <img src={Shopping} className=' w-full h-full object-cover' alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login